import { createReducer, on } from '@ngrx/store';
import { setAuth } from './auth.actions';
import { AuthConfig } from '@/app/_core/domain/models/auth/auth.model';

export interface AuthState {
  auth: AuthConfig;
}

export const initialAuthState: AuthState = {
  auth: null
};

export const reducer = createReducer<AuthState>(
  initialAuthState,
  on(setAuth, (state, action) => ({
    ...state,
    auth: action.payload.auth
  }))
);
